export default __webpack_public_path__ + "static/media/listingBanner.47bdb1bf.svg";